import React, { useState, useEffect, useRef } from "react"
import { Link, useNavigate } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import userAvatar from "../assets/img/img1.jpg";
import { Spinner, Badge } from "react-bootstrap";
import { API_BASE_URL } from "../constants/api";

export default function Header({ onSkin }) {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loadingNotifications, setLoadingNotifications] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  
  const intervalRef = useRef(null);

  useEffect(() => {
    const checkUser = () => {
      try {
        const userStr = localStorage.getItem("user");
        
        if (userStr && userStr !== "undefined" && userStr !== "null") {
          const userData = JSON.parse(userStr);
          
          if (userData && (userData.id_utilisateur || userData.id)) {
            setUser(userData);
            setIsLoggedIn(true);
          } else {
            localStorage.removeItem("user");
            setUser(null);
            setIsLoggedIn(false);
          }
        } else {
          setUser(null);
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error("Erreur parsing utilisateur:", error);
        localStorage.removeItem("user");
        setUser(null);
        setIsLoggedIn(false);
      }
    };

    checkUser();
    
    const handleStorageChange = (e) => {
      if (e.key === "user") {
        checkUser();
      }
    };
    
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const fetchNotifications = async (isAutoRefresh = false) => {
    // try {
    //   const token = localStorage.getItem("token");
      
    //   if (isAutoRefresh) {
    //     setIsRefreshing(true);
    //   } else {
    //     setLoadingNotifications(true);
    //   }
      
    //   const response = await fetch(
    //     `${API_BASE_URL}/notifications.php?action=all&limit=10`,
    //     { headers: { 'Authorization': `Bearer ${token}` } }
    //   );
      
    //   if (response.ok) {
    //     const result = await response.json();
    //     if (result.success) {
    //       const previousCount = unreadCount;
    //       setNotifications(result.data);
    //       setUnreadCount(result.unread || 0);
          
    //       if (result.unread > previousCount && previousCount > 0) {
    //         console.log("🔔 Nouvelles notifications!");
    //       }
    //     }
    //   }
    // } catch (error) {
    //   console.error("Erreur chargement notifications:", error);
    // } finally {
    //   if (isAutoRefresh) {
    //     setIsRefreshing(false);
    //   } else {
    //     setLoadingNotifications(false);
    //   }
    // }
  };

  useEffect(() => {
    if (isLoggedIn && user) {
      fetchNotifications(false);
      
      intervalRef.current = setInterval(() => {
        fetchNotifications(true);
      }, 30000);
      
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }
  }, [isLoggedIn, user]);

  const markAsRead = async (notificationId) => {
    try {
      const token = localStorage.getItem("token");
      
      const response = await fetch(
        `${API_BASE_URL}/notifications.php`,
        {
          method: 'PUT',
          headers: { 
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json' 
          },
          body: JSON.stringify({ notification_id: notificationId, read: true })
        }
      );
      
      if (response.ok) {
        setNotifications(prev => 
          prev.map(n => 
            n.id === notificationId ? { ...n, read: true } : n
          )
        );
        setUnreadCount(prev => Math.max(0, prev - 1));
      }
    } catch (error) {
      console.error("Erreur marquage notification:", error);
    }
  };

  const markAllAsRead = async () => {
    
  };

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Link
      to=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className="dropdown-link"
    >
      {children}
    </Link>
  ));

  const toggleSidebar = (e) => {
    e.preventDefault();
    let isOffset = document.body.classList.contains("sidebar-offset");
    if (isOffset) {
      document.body.classList.toggle("sidebar-show");
    } else {
      if (window.matchMedia("(max-width: 991px)").matches) {
        document.body.classList.toggle("sidebar-show");
      } else {
        document.body.classList.toggle("sidebar-hide");
      }
    }
  }

  const handleLogout = (e) => {
    if (e) e.preventDefault();
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/pages/signin2");
  };

  const getUserInitials = () => {
    if (!user) return 'U';
    
    const prenom = user.prenom || user.prenom_utilisateur || '';
    const nom = user.nom || user.nom_utilisateur || '';
    
    const initialPrenom = prenom ? prenom.charAt(0).toUpperCase() : '';
    const initialNom = nom ? nom.charAt(0).toUpperCase() : '';
    
    return initialPrenom + initialNom || 'U';
  };

  const getUserFullName = () => {
    if (!user) return 'Utilisateur';
    
    const prenom = user.prenom || user.prenom_utilisateur || '';
    const nom = user.nom || user.nom_utilisateur || '';
    
    return (prenom + ' ' + nom).trim() || 'Utilisateur';
  };

  const getUserRole = () => {
    if (!user || !user.role) return 'Non connecté';
    
    const roles = {
      'admin': 'Administrateur',
      'gestionnaire': 'Gestionnaire',
      'commercial': 'Commercial',
      'magasinier': 'Magasinier'
    };
    
    return roles[user.role] || user.role;
  };

  const getRoleColor = () => {
    if (!user || !user.role) return '#64748b';
    
    const colors = {
      'admin': '#dc2626',
      'gestionnaire': '#f59e0b',
      'commercial': '#3b82f6',
      'magasinier': '#10b981'
    };
    
    return colors[user.role] || '#21ACCD';
  };

  const skinMode = (e) => {
    e.preventDefault();
    
    const parent = e.target.parentNode;
    if (parent) {
      const nodes = parent.children;
      for (let node of nodes) {
        node.classList.remove("active");
      }
    }
    
    e.target.classList.add("active");
    
    let skin = e.target.textContent.toLowerCase();
    let HTMLTag = document.querySelector("html");

    if (skin === "dark") {
      HTMLTag.setAttribute("data-skin", skin);
      localStorage.setItem('skin-mode', skin);
      if (onSkin) onSkin(skin);
    } else {
      HTMLTag.removeAttribute("data-skin");
      localStorage.removeItem('skin-mode');
      if (onSkin) onSkin('');
    }
  };

  const sidebarSkin = (e) => {
    e.preventDefault();
    
    const parent = e.target.parentNode;
    if (parent) {
      const nodes = parent.children;
      for (let node of nodes) {
        node.classList.remove("active");
      }
    }
    
    e.target.classList.add("active");

    let skin = e.target.textContent.toLowerCase();
    let HTMLTag = document.querySelector("html");

    HTMLTag.removeAttribute("data-sidebar");

    if (skin !== "default") {
      HTMLTag.setAttribute("data-sidebar", skin);
      localStorage.setItem("sidebar-skin", skin);
    } else {
      localStorage.removeItem("sidebar-skin");
    }
  };

  const getNotificationIcon = (type) => {
    const icons = {
      'stock_critique': 'ri-alert-line',
      'rupture_stock': 'ri-close-circle-line',
      'inventaire': 'ri-file-list-3-line',
      'commande': 'ri-shopping-cart-line',
      'facture': 'ri-file-list-line',
      'devis': 'ri-file-copy-line',
      'paiement': 'ri-bank-card-line',
      'utilisateur': 'ri-user-line'
    };
    return icons[type] || 'ri-notification-line';
  };

  const getNotificationColor = (type) => {
    const colors = {
      'stock_critique': '#dc2626',
      'rupture_stock': '#dc2626',
      'inventaire': '#3b82f6',
      'commande': '#f59e0b',
      'facture': '#10b981',
      'devis': '#8b5cf6',
      'paiement': '#10b981',
      'utilisateur': '#64748b'
    };
    return colors[type] || '#21ACCD';
  };

  const getRelativeTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHour = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHour / 24);
    
    if (diffSec < 60) return "À l'instant";
    if (diffMin < 60) return `Il y a ${diffMin} min`;
    if (diffHour < 24) return `Il y a ${diffHour}h`;
    if (diffDay < 7) return `Il y a ${diffDay}j`;
    return date.toLocaleDateString();
  };

  const NotificationList = () => {
    if (loadingNotifications && !isRefreshing) {
      return (
        <li className="list-group-item text-center py-4">
          <Spinner animation="border" size="sm" style={{ color: '#21ACCD' }} />
          <p className="mt-2 small text-muted">Chargement...</p>
        </li>
      );
    }

    if (!notifications || notifications.length === 0) {
      return (
        <li className="list-group-item text-center py-4">
          <i className="ri-notification-off-line fs-1 text-muted mb-2"></i>
          <p className="text-muted small">Aucune notification</p>
        </li>
      );
    }

    return notifications.slice(0, 5).map((item, index) => (
      <li 
        className={`list-group-item notification-item ${!item.read ? 'unread' : ''}`} 
        key={index}
        onClick={() => !item.read && markAsRead(item.id)}
      >
        <div className="d-flex gap-3">
          <div className="notification-icon" style={{ backgroundColor: `${getNotificationColor(item.type)}15`, color: getNotificationColor(item.type) }}>
            <i className={getNotificationIcon(item.type)}></i>
          </div>
          <div className="list-group-body flex-grow-1">
            <div className="d-flex justify-content-between align-items-start mb-1">
              <p className="mb-0 fw-semibold small">{item.title}</p>
              {!item.read && (
                <Badge className="notification-new-badge" style={{ background: '#21ACCD' }}>
                  Nouveau
                </Badge>
              )}
            </div>
            <p className="small text-muted mb-1">{item.message}</p>
            <div className="d-flex align-items-center gap-2">
              <i className="ri-time-line small text-muted"></i>
              <span className="small text-muted">{getRelativeTime(item.created_at)}</span>
            </div>
          </div>
        </div>
      </li>
    ));
  };

  return (
    <div className="header-main px-3 px-lg-4">
      <Link onClick={toggleSidebar} className="menu-link me-3 me-lg-4">
        <i className="ri-menu-2-fill"></i>
      </Link>

      <div className="form-search me-auto">
        <input type="text" className="form-control" placeholder="Rechercher..." />
        {/* <i className="ri-search-line"></i> */}
      </div>

      {/* Dropdown Skin */}
      {/* <Dropdown className="dropdown-skin" align="end">
        <Dropdown.Toggle as={CustomToggle}>
          <i className="ri-palette-line"></i>
        </Dropdown.Toggle>
        <Dropdown.Menu className="mt-10-f">
          <div className="dropdown-menu-header">
            <h6 className="dropdown-menu-title">Changer le thème</h6>
          </div>
          <div className="dropdown-menu-body">
            <div className="d-flex justify-content-around mb-3">
              <Link to="#" className="skin" onClick={skinMode}>
                <div className="skin-default"></div>
                <span>Clair</span>
              </Link>
              <Link to="#" className="skin" onClick={skinMode}>
                <div className="skin-dark"></div>
                <span>Sombre</span>
              </Link>
            </div>
            <hr className="my-2" />
            <div className="dropdown-menu-header mt-2">
              <h6 className="dropdown-menu-title">Style de sidebar</h6>
            </div>
            <div className="d-flex justify-content-around">
              <Link to="#" className="skin" onClick={sidebarSkin}>
                <div className="sidebar-default"></div>
                <span>Default</span>
              </Link>
              <Link to="#" className="skin" onClick={sidebarSkin}>
                <div className="sidebar-dark"></div>
                <span>Sombre</span>
              </Link>
              <Link to="#" className="skin" onClick={sidebarSkin}>
                <div className="sidebar-colored"></div>
                <span>Couleur</span>
              </Link>
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown> */}

      {/* Notifications modernisées */}
      {/* <Dropdown className="dropdown-notification ms-3 ms-xl-4" align="end">
        <Dropdown.Toggle as={CustomToggle}>
          {unreadCount > 0 && <small className="notification-badge">{unreadCount}</small>}
          <i className={`ri-notification-3-line ${isRefreshing ? 'refreshing' : ''}`}></i>
          {isRefreshing && (
            <span className="refresh-spinner">
              <span className="spinner-grow spinner-grow-sm" style={{ width: '8px', height: '8px', background: '#21ACCD' }}></span>
            </span>
          )}
        </Dropdown.Toggle>
        <Dropdown.Menu className="mt-10-f notification-dropdown">
          <div className="dropdown-menu-header d-flex justify-content-between align-items-center px-3 py-2">
            <h6 className="dropdown-menu-title mb-0">
              Notifications
              {unreadCount > 0 && (
                <Badge className="ms-2" style={{ background: '#21ACCD' }}>{unreadCount} non lue(s)</Badge>
              )}
            </h6>
            {unreadCount > 0 && (
              <Link 
                to="#" 
                className="small text-decoration-none"
                style={{ color: '#21ACCD' }}
                onClick={(e) => {
                  e.preventDefault();
                  markAllAsRead();
                }}
              >
                Tout marquer lu
              </Link>
            )}
          </div>
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            <ul className="list-group list-group-flush">
              <NotificationList />
            </ul>
          </div>
          <div className="dropdown-menu-footer text-center py-2">
            <Link to="#" className="small text-decoration-none" style={{ color: '#21ACCD' }}>
              Voir toutes les notifications
            </Link>
          </div>
        </Dropdown.Menu>
      </Dropdown> */}

      {/* Profil utilisateur modernisé */}
      <Dropdown className="dropdown-profile ms-3 ms-xl-4" align="end">
        <Dropdown.Toggle as={CustomToggle}>
          <div className="avatar online">
            {isLoggedIn && user ? (
              <div className="avatar-initials" style={{ backgroundColor: getRoleColor() }}>
                {getUserInitials()}
              </div>
            ) : (
              <img src={userAvatar} alt="Avatar par défaut" />
            )}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="mt-10-f profile-dropdown">
          <div className="dropdown-menu-body text-center p-3">
            <div className="profile-avatar mb-3">
              <div className="avatar avatar-xl online mx-auto">
                {isLoggedIn && user ? (
                  <div className="avatar-initials-large" style={{ backgroundColor: getRoleColor() }}>
                    {getUserInitials()}
                  </div>
                ) : (
                  <img src={userAvatar} alt="Avatar par défaut" />
                )}
              </div>
            </div>
            <h5 className="mb-1 fw-semibold">{getUserFullName()}</h5>
            <p className="small mb-2" style={{ color: getRoleColor() }}>{getUserRole()}</p>
            <p className="small text-muted mb-3">
              <i className="ri-mail-line me-1"></i>
              {user?.email || 'email@exemple.com'}
            </p>

            <nav className="nav flex-column gap-1">
              <Link to="/pages/edit-profile" className="profile-menu-link">
                <i className="ri-edit-2-line"></i>
                Modifier profil
              </Link>
              <Link to="/pages/profile" className="profile-menu-link">
                <i className="ri-profile-line"></i>
                Voir profil
              </Link>
              <Link to="/pages/aide" className="profile-menu-link">
                <i className="ri-question-line"></i>
                Centre d'aide
              </Link>
              <hr className="my-2" />
              <Link to="#" onClick={handleLogout} className="profile-menu-link text-danger">
                <i className="ri-logout-box-r-line"></i>
                Déconnexion
              </Link>
            </nav>
          </div>
        </Dropdown.Menu>
      </Dropdown>

      <style>{`
        /* Header styles modernisés */
        .header-main {
          background: white;
          border-bottom: 1px solid #e2e8f0;
          height: 70px;
          display: flex;
          align-items: center;
        }

        .menu-link {
          color: #64748b;
          font-size: 1.5rem;
          transition: all 0.3s ease;
        }

        .menu-link:hover {
          color: #21ACCD;
        }

        /* Search bar */
        .form-search {
          position: relative;
          width: 300px;
        }

        .form-search .form-control {
          border-radius: 40px;
          border: 1px solid #e2e8f0;
          padding: 0.6rem 1rem 0.6rem 2.5rem;
          font-size: 0.9rem;
          transition: all 0.3s ease;
        }

        .form-search .form-control:focus {
          border-color: #21ACCD;
          box-shadow: 0 0 0 3px rgba(33, 172, 205, 0.1);
        }

        .form-search i {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          font-size: 1rem;
        }

        /* Notification badge */
        .dropdown-notification {
          position: relative;
        }

        .dropdown-link {
          position: relative;
          display: flex;
          align-items: center;
          color: #64748b;
          font-size: 1.25rem;
          transition: all 0.3s ease;
        }

        .dropdown-link:hover {
          color: #21ACCD;
        }

        .notification-badge {
          position: absolute;
          top: -8px;
          right: -8px;
          background: #ef4444;
          color: white;
          border-radius: 50%;
          width: 18px;
          height: 18px;
          font-size: 0.65rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
        }

        .dropdown-notification .refreshing {
          color: #21ACCD;
        }

        .refresh-spinner {
          position: absolute;
          bottom: -2px;
          right: -6px;
        }

        /* Notification dropdown */
        .notification-dropdown {
          width: 380px;
          border: none;
          border-radius: 16px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }

        .notification-item {
          transition: all 0.3s ease;
          cursor: pointer;
          padding: 1rem;
        }

        .notification-item:hover {
          background: #f8fafc;
        }

        .notification-item.unread {
          background: #f0f9ff;
        }

        .notification-icon {
          width: 40px;
          height: 40px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.25rem;
          flex-shrink: 0;
        }

        .notification-new-badge {
          font-size: 0.65rem;
          padding: 0.2rem 0.5rem;
          border-radius: 50px;
        }

        /* Avatar initials */
        .avatar-initials {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1rem;
          font-weight: 600;
          color: white;
          text-transform: uppercase;
        }

        .avatar-initials-large {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1rem;
          font-weight: 700;
          color: white;
          text-transform: uppercase;
        }

        /* Profile dropdown */
        .profile-dropdown {
          width: 320px;
          border: none;
          border-radius: 16px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }

        .profile-menu-link {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 0.6rem 1rem;
          color: #64748b;
          text-decoration: none;
          border-radius: 12px;
          transition: all 0.3s ease;
        }

        .profile-menu-link i {
          font-size: 1.1rem;
          width: 24px;
        }

        .profile-menu-link:hover {
          background: #f1f5f9;
          color: #21ACCD;
        }

        .profile-menu-link.text-danger:hover {
          background: #fef2f2;
          color: #dc2626;
        }

        /* Dropdown menu header/footer */
        .dropdown-menu-header {
          padding: 0.75rem 1rem;
          border-bottom: 1px solid #e2e8f0;
          background: #f8fafc;
        }

        .dropdown-menu-title {
          font-size: 0.9rem;
          font-weight: 600;
          color: #1e293b;
        }

        .dropdown-menu-footer {
          border-top: 1px solid #e2e8f0;
          background: #f8fafc;
        }

        /* Skin selector */
        .skin {
          text-align: center;
          text-decoration: none;
        }

        .skin div {
          width: 50px;
          height: 50px;
          border-radius: 12px;
          margin-bottom: 0.5rem;
          transition: all 0.3s ease;
        }

        .skin:hover div {
          transform: scale(1.05);
        }

        .skin-default { background: #ffffff; border: 2px solid #e2e8f0; }
        .skin-dark { background: #1e293b; border: 2px solid #334155; }
        .sidebar-default { background: #ffffff; border: 2px solid #e2e8f0; }
        .sidebar-dark { background: #1e293b; border: 2px solid #334155; }
        .sidebar-colored { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }

        .skin span {
          font-size: 0.75rem;
          color: #64748b;
        }

        .skin.active div {
          border: 2px solid #21ACCD;
          box-shadow: 0 0 0 2px rgba(33, 172, 205, 0.3);
        }

        /* Responsive */
        @media (max-width: 768px) {
          .form-search {
            display: none;
          }
          
          .notification-dropdown,
          .profile-dropdown {
            width: 320px;
          }
        }
      `}</style>
    </div>
  )
}